import * as apisPortal from '/@src/client-portal/api'
import * as apisPublic from '/@src/client-public/api'

export const getOsobyApi = () => new apisPortal.OsobyApi()
export const getOrganizacieApi = () => new apisPortal.OrganizacieApi()
export const getSubjektApi = () => new apisPortal.SubjektyApi()
export const getPortalOsobaApi = () => new apisPortal.PortalOsobaApi()
export const getPouzivateliaApi = () => new apisPortal.PortalPouzivateliaApi()
export const getZoppmDraftApi = () => new apisPortal.ZoppmDraftApi()
export const getPublicVyzvaApi = () => new apisPublic.PublicVyzvaApi()
export const getPortalPouzivatelApi = () => new apisPortal.PortalPouzivatelApi()
